import React, {useRef} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {Button} from "../../../../../components/Button";
import {Icons1} from "../../../../../icons/Icons1";
import {Icons19} from "../../../../../icons/Icons19";
import {NameMenuDarkTrue} from "../../../../../icons/NameMenuDarkTrue";
import {TrailingIcon14} from "../../../../../icons/TrailingIcon14";
import {TrailingIcon19} from "../../../../../icons/TrailingIcon19";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import {FrameCorp} from "../../../../../components/FrameCorp";
import "./style.css";

export const CorporativoLandingRegional = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const colors = useDynamicColors();
  const scrollRef = useRef(null);

  const handleButtonClick = () => {
    const currentParams = location.search;
    navigate(`/regional_retail-onboarding_card_id-corporativo-mobile${currentParams}`);
  };

  return (
    <div className="contenedor">
      <div className="corporativo-landing" ref={scrollRef}>
        {/* {isFocused && <div className="overlay" onClick={toggleFocus}></div>} */}
        <div className="div-3">
          <div className="overlap-3">
            <header className="header">
              <div className="overlap-group-7">
                <div className="rectangle-4" />

                <div className="frame-6">
                  <FrameCorp color={colors.septimo} />
                </div>

                <div className="frame-7">
                  <div className="text-wrapper-11">Good morning, Mary</div>

                  <div className="frame-8">
                    <Icons1 className="icon-instance-node-2" color="white" />
                    <NameMenuDarkTrue
                      className="icon-instance-node-2"
                      color="white"
                    />
                  </div>
                </div>
              </div>
            </header>

            <img className="vector-2" alt="Vector" src="/img/vector-101.svg" />

            <div className="frame-9">
              <div className="accounts">
                <div className="tarjtetas">
                  <div className="title">Accounts</div>

                  <div className="frame-10">
                    <Icons19 className="icon-instance-node-2" color="white" />
                    <div className="menu-copy">
                      <div className="oval" />

                      <div className="oval-2" />

                      <div className="oval-3" />
                    </div>
                  </div>
                </div>

                <div
                  className="account highlighted-button"
                  onClick={handleButtonClick}
                >
                  <div className="frame-11">
                    <div className="text-wrapper-12">Balance</div>

                    <p className="element-USD">
                      <span className="span">$13,000</span>

                      <span className="text-wrapper-13">.23</span>

                      <span className="text-wrapper-14">&nbsp;</span>

                      <span className="text-wrapper-15">USD</span>
                    </p>
                  </div>

                  <div className="frame-12">
                    <p className="main-account">
                      <span className="span">Main account </span>

                      <span className="text-wrapper-16">| ****2357</span>
                    </p>

                    <Button
                      className="button-instance"
                      divClassName="button-4"
                      leadingIcon={false}
                      size="small"
                      text="Transactions"
                      trailingIcon
                      trailingIcon14StyleOverrideClassName="button-5"
                      trailingIcon14Color={colors.secundario}
                      type="text"
                    />
                  </div>
                </div>

                <div className="button-6">
                  <div className="text-wrapper-17">More</div>

                  <TrailingIcon19 className="trailing-icon" />
                </div>
              </div>

              <div className="botonera">

                <div className="frame-14">
                  <div className="overlap-group-wrapper">
                    <div className="overlap-group-8">

                      <div className='border-vector-3'>
                      <img
                          className="vector-3"
                          alt="Vector"
                          src="/img/iconZellePng.png"
                      />
                      </div>
                    </div>
                  </div>

                  <div className="texto-iconos">Zelle</div>
                </div>

                <div className="frame-13">
                  <img
                      className="btn-icon-contacts"
                      alt="Btn icon contacts"
                      src="/img/btn-icon-contacts-2.svg"
                  />

                  <div className="texto-iconos">Wired Transfers</div>
                </div>

                <div className="frame-13">
                  <img
                      className="invoice"
                      alt="Invoice"
                      src="/img/invoice.svg"
                  />

                  <div className="texto-iconos">Pay Bills</div>
                </div>


                <div className="frame-15">
                  <img className="plus" alt="Plus" src="/img/plus.svg"/>

                  <div className="texto-iconos">CNEx</div>
                </div>
              </div>

              <div className="cards">
                <div className="div-4">
                  <div className="title-2">Cards</div>

                  <div className="frame-16">
                    <Icons19
                        className="icon-instance-node-2"
                        color={colors.secundario}
                    />
                    <div className="menu-copy">
                      <div className="oval-4"/>

                      <div className="oval-5"/>

                      <div className="oval-6"/>
                    </div>
                  </div>
                </div>

                <div className="cardss">
                  <div className="gold">
                    <div className="div-4">
                      {/* <img className="shape" alt="Shape" src="/img/shape.svg" /> */}

                      <div className="text-wrapper-21">
                        Credit GOLD ****5849
                      </div>

                      <TrailingIcon19 className="trailing-icon" />
                    </div>
                  </div>

                  {/* <div className="silver">
                    <div className="frame-17">
                      <div className="logo-mastercard">
                        <div className="shapes">
                          <img
                            className="mastercard"
                            alt="Mastercard"
                            src="/img/mastercard.svg"
                          />

                          <div className="overlap-group-9">
                            <img
                              className="middle"
                              alt="Middle"
                              src="/img/middle.svg"
                            />

                            <img className="red" alt="Red" src="/img/red.svg" />

                            <img
                              className="orange"
                              alt="Orange"
                              src="/img/orange.svg"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="text-wrapper-21">
                        Credit SILVER ****2345
                      </div>

                      <ChevronRight
                        chevronRight="/img/trailing-icon-21.png"
                        className="chevron-right-instance"
                      />
                    </div>
                  </div> */}
                </div>

                {/* <div className="img-slider-dots">
                  <SliderDots className="slider-dots-instance" status="on" />
                  <SliderDots className="slider-dots-2" status="off" />
                </div> */}
              </div>

              <div className="balances">
                <div className="div-5">
                  <img
                    className="group-2"
                    alt="Group"
                    src="/img/group-637-2.svg"
                  />

                  <div className="frame-18">
                    <div className="frame-19">
                      <div className="ellipse-4" />

                      <p className="div-6">
                        <span className="span">
                          T. Balance
                          <br />
                        </span>

                        <span className="text-wrapper-22">$13,000</span>
                      </p>
                    </div>

                    <div className="frame-19">
                      <div className="ellipse-5" />

                      <p className="div-6">
                        <span className="span">
                          Debts
                          <br />
                        </span>

                        <span className="text-wrapper-22">$8,000</span>
                      </p>
                    </div>
                  </div>

                  <div className="frame-20">
                    <div className="text-wrapper-23">Total balance | Debts</div>

                    <TrailingIcon14
                      className="trailing-icon"
                      style={{ color: colors.primario }}
                    />
                  </div>
                </div>

                <div className="div-5">
                  <div className="frame-21">
                    <div className="frame-22">
                      <div className="text-wrapper-23">
                        Expenses &amp; Incomes
                      </div>

                      <TrailingIcon14
                        className="trailing-icon"
                        style={{ color: colors.primario }}
                      />
                    </div>

                    <div className="chart">
                      <div className="frame-23">
                        <div className="rectangle-5" />

                        <div className="rectangle-6" />
                      </div>

                      <div className="frame-23">
                        <div className="rectangle-7" />

                        <div className="rectangle-8" />
                      </div>
                    </div>

                    <div className="frame-24">
                      <div className="text-wrapper-24">September</div>

                      <div className="frame-25">
                        <div className="expenses-wrapper">
                          <div className="text-wrapper-24">
                            Expenses
                            <br />
                            $2,000
                          </div>
                        </div>

                        <div className="incomes-wrapper">
                          <div className="text-wrapper-24">
                            Incomes
                            <br />
                            $3,200
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="banners">
                <div className="overlap-wrapper">
                  <div className="overlap-4">
                    <img
                      className="image-2"
                      alt="Image"
                      src="/img/image-62026.png"
                    />

                    <div className="frame-26">
                      <img
                        className="image-3"
                        alt="Image"
                        src="/img/image-62032.png"
                      />

                      <div className="group-3">
                        <div className="overlap-group-10">
                          <p className="in-all-TACOS">
                            <span className="text-wrapper-25">
                              in all
                              <br />
                            </span>

                            <span className="text-wrapper-26">TACOS</span>
                          </p>

                          <p className="element-OFF">
                            <span className="text-wrapper-27">40</span>

                            <span className="text-wrapper-28">%OFF</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <img
                  className="image-4"
                  alt="Image"
                  src="/img/image-62014.png"
                />

                <img
                  className="image-5"
                  alt="Image"
                  src="/img/image-62011.png"
                />

                <img
                  className="image-4"
                  alt="Image"
                  src="/img/image-62017.png"
                />
              </div>
            </div>

            {/* <div className="content-wrapper">
              <div className="content-3">
                <div className="text-wrapper-29">9:50</div>

                <img className="icons-2" alt="Icons" src="/img/icons.svg" />
              </div>
            </div> */}
          </div>


        </div>
      </div>
    </div>
  );
};
